import { useRoute, createRouter, createMemoryHistory, RouteRecordRaw } from 'vue-router';

const routerList: Array<RouteRecordRaw> = [
  {
    path: '/AccountPassword',
    component: () => import('../components/AccountPassword.vue'),
  },
  {
    path: '/WX',
    component: () => import('../components/WX.vue'),
  },
  {
    path: '/WXWork',
    component: () => import('../components/WXWork.vue'),
  },
  {
    path: '/Alipay',
    component: () => import('../components/Alipay.vue'),
  },
  // {
  //   path: '/DingTalk',
  //   component: () => import('../components/DingTalk.vue'),
  // },
  {
    path: '/ChangePassword',
    component: () => import('../components/ChangePassword.vue'),
  },
  {
    path: '/Result/:type/:title/:description/:showReturn?/:goBackUrl?',
    props: true,
    component: () => import('../components/Result.vue'),
  },
  {
    path: '/SetRecoveryEmail',
    component: () => import('../components/SetRecoveryEmail.vue'),
  },
  {
    path: '/CompleteMobile',
    component: () => import('../components/CompleteMobile.vue'),
  },
];

const router = createRouter({
  history: createMemoryHistory(),
  routes: routerList,
  scrollBehavior() {
    return {
      el: '#app',
      top: 0,
      behavior: 'smooth',
    };
  },
});

export default router;
